export default __webpack_public_path__ + "static/media/kinesis.7a790f22.png";